export enum DispatchingRuleSearchOrder {
  OrderByDispatchingRuleId = 1,
  OrderByName = 2,
  OrderByPriority = 3,
}
